import { render, staticRenderFns } from "./AppDefaultLayout.vue?vue&type=template&id=6964eff4&"
import script from "./AppDefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./AppDefaultLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports